'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _targetEnhancement = require('@nimius/target-enhancement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _targetEnhancement.initializeGlobalTargetEnhancement)();

function isTargetEnhanceLink(link) {
    var allowedHosts = ['fonds-super-markt.de', 'www.fonds-super-markt.de', 'infosfsm-001.nimius-wip.de', 'www.infosfsm-001.nimius-wip.de', window.location.hostname];

    return allowedHosts.indexOf(link.hostname) !== -1 && link.hash;
}

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('.tab-content a')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var link = _step.value;

        if (isTargetEnhanceLink(link)) {
            (function () {
                var targetEnhancedLink = document.querySelector('[data-target-enhancement][href="' + link.hash + '"]');
                link.addEventListener('click', function (event) {
                    event.preventDefault();
                    targetEnhancedLink.click();
                });
            })();
        }
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./Resources/Private/Javascript/target-enhancement.js
// module id = 139
// module chunks = 4